const Gfunc =require("../Gfunc")


  export const Caisse=async ()=>{
    const response=await Gfunc.axiosGetAction('_cai.php' ,'getcaisse')
    if(response.data.jData)   {
      Gfunc.updateElem("caisseIr",response.data.jData)   
    } 
  }
  